<template>
    <div>
        <form id="cnfmForm" name="cnfmForm" method="post" action="">
        </form>
        <v-dialog/>
    </div>
</template>

<script>
// import { getIpinDecrypt } from '@/api/common'
export default {
    name: "ResultIpinAuthPop",
    data() {
        return {
            encData: '',
            certRequestNum: '',
            custNm: '',
            custBday: '',
            custIpinCiNo: '',
            certDate: ''
        }
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        /** 
         * Function    : getInfo
         * Description : 아이핀 결과 정보
         **/
        getInfo() {
            let ret = decodeURIComponent(window.atob(decodeURIComponent(this.$route.query.ret)))
            let custInfo = ''
            if (ret) {
                custInfo = ret.split(',')
                if (custInfo === undefined || custInfo.length < 0 || custInfo === null)  {
                    alert('인증을 실패 했습니다.')
                    window.close()
                } else {
                    alert("본인인증이 성공하였습니다.");

                    if(typeof(window.parent.cbAuthPop) == "function") {
                        window.parent.cbAuthPop(ret)
                    } else {
                        window.opener.cbAuthPop(ret)
                        window.close()
                    }
                    
                }
            } else {
                alert('인증을 실패 했습니다')
                window.close()
            }
        // this.encData = this.$route.query.encData
        // //    this.certRequestNum = this.$route.qeury.certRequestNum
        // if(this.encData) {
        //     ipinSave(this.encData).then(res => {
        //         if(res.data.rsltCd === "SUCCESS") {
        //             window.opener.cbAuthPop({
        //                 name: res.data.custNm,
        //                 phoneNo: '',
        //                 birthDay: res.data.custBday,
        //                 certNum: res.data.certRequestNum
        //             })
        //             window.close()
        //         } else {
        //             alert('인증을 실패 했습니다.\n다시 시도해주세요.')
        //             window.close()
        //         }
        //     })
        // } else {
        //     alert('인증을 실패 했습니다.\n다시 시도해주세요.')
        //     window.close()
        // }


        //    getIpinDecrypt({ encData: this.encData }).then(res => {
            //    if (res.data.rsltCd === 'FAIL') {
            //        alert(res.data.rsltMsg)
            //        window.close()
            //    } else {
            //        this.custNm = res.data.custNm // 이름
            //        this.custBday = res.data.custBday // 생년월일 (YYYYMMDD)
            //        window.opener.cbAuthPop({
            //            name: res.data.custNm,
            //            phoneNo: '',
            //            birthDay: res.data.custBday,
            //        })
            //        window.close()
            //    }
        //    })
        },
    },
}
</script>

<style scoped>

</style>